

import Action4 from './action4';

export default class {

    static extends = [Action4]

    showAbc() {
        console.log('abc');
    }
}